import * as Yup from "yup";

export const signUpSchema = Yup.object({
    name:Yup.string().min(2).max(25).required("Please Enter Your name"),
    email:Yup.string().email().required("Please Enter Your Email"),
    message:Yup.string().min(3).required("Please Enter Your Feedback"),

})